<template>
  <refonte-modal
    v-bind:show="props.show"
    v-on:close="props.on_close"
    v-bind:title="props.title"
    class="!max-w-[640px]">
    <template v-slot:modalBody>
      <div class="flex flex-col gap-[12px]">
        <span v-if="props.show_body">
          Vous avez signé électroniquement le PIF le
          <span class="font-bold">{{ formatDate(props.date) }}</span>
          .
        </span>
      </div>
    </template>
    <template v-slot:modalFooter>
      <refonte-button
        v-if="props.on_close"
        variant="primary"
        v-bind:on_click="props.on_close">
        Fermer
      </refonte-button>
    </template>
  </refonte-modal>
</template>

<script setup lang="ts">
  import RefonteModal from '@/components/refonte/modals/refonte-modal.vue';
  import RefonteButton from '@/components/refonte/buttons/refonte-button.vue';
  import { parse } from 'date-fns';
  const props = withDefaults(
    defineProps<{
      show: boolean;
      on_close: Function;
      class?: string;
      title: string;
      show_body: boolean;
      date?: string;
    }>(),
    {
      class: '',
      show_body: false,
      verb: 'signée'
    }
  );

  const formatDate = (dateString: string | undefined) => {
    if (!dateString) return '';
    const date = parse(dateString, 'dd/MM/yyyy HH:mm:ss', new Date());

    const datePart = date.toLocaleDateString('fr-FR');
    const timePart = date
      .toLocaleTimeString('fr-FR', {
        hour: '2-digit',
        minute: '2-digit'
      })
      .replace(':', 'h');

    return `${datePart} à ${timePart}`;
  };
</script>

<style lang="scss" scoped></style>
